export var CreateTripFormInitialData = {
    tripName: "",
    tripCategories: [],
    source: "",
    destination: "",
    startDate: "",
    status: "YET_TO_START",
    endDate: "",
    description: "",
    highlights: [],
    inclusions: [],
    exclusions: [],
    itinerary: [],
    coverImage: null,
    galleryImages: [],
    videoUrl: "",
    privacySetting: "public",
    locationDetails: {
        latitude: null,
        longitude: null,
        meetingPoint: "",
        meetingTime: "",
    },
    modeOfTransport: "",
    maxParticipant: 0,
};
